export const RowType = {
	LabelAndInput: 'labelAndInput',
	PostalCodeAndPhone: 'postalCodeAndPhone',
	IsAccountSearchableForNewUsers: 'isAccountSearchableForNewUsers',
	SocialLinkMediaInputRow: 'socialLinkMediaInputRow',
};
